export default __webpack_public_path__ + "df756c441866f79a26140de163402ae0.png";